module.exports = __webpack_public_path__ + "/login_ui/img/sm-83fe677c584683439a3c7a8f460c14fe.svg";